export enum SignedOutPermissions {
  MonitorJunior = 'monitor-junior',
  MonitorTodoJunior = 'monitor-todo-junior',
}
